import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { ensureVisitReasonPresence } from "@/modules/scheduling/router/guardians"

export default [
  {
    path: "/sarah-layout-scheduling",
    component: () => import("@/layouts/enrollment-new/EnrollmentLayout.vue"),
    children: [
      {
        path: "/schedule",
        name: "appointment-scheduling",
        meta: { requiresAuth: true },
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureVisitReasonPresence])
        },
        component: () => import("@/modules/scheduling/pages/appointment-scheduling/AppointmentSchedulingPage.vue")
      }
    ]
  }
]
